<template>
  <div>
    <navigation />
    <section class="section is-medium" id="privacy">
      <div class="container">
        <div class="content">
          <h1 class="title is-2 is-size-4-mobile">
            {{ $t("views.privacy.headline") }}
          </h1>
          <hr class="is-placeholder is-hidden-mobile" />

          <div class="notification is-info is-light">
            <p>
              {{ $t("views.privacy.description") }}
            </p>
            <p>
              <a
                href="/files/RepGuide-Datenschutzerklaerung-DACH-Mai-2022.pdf"
                target="_blank"
              >
                <button class="button is-info">
                  {{ $t("views.privacy.cta") }}
                </button>
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
    <footerNavigation />
  </div>
</template>

<script>
import navigation from "../components/navigation.vue";
import footerNavigation from "../components/footerNavigation.vue";

export default {
  name: "privacy",
  components: {
    navigation,
    footerNavigation,
  },
};
</script>
